import React from "react";
import PropTypes from "prop-types";

const SummaryDataItem = ({ itemAmount, itemTitle }) => {
  return (
    <div
      data-testid="summary-data-item"
      className="summary-data-item-container"
    >
      <div className="summary-data-title">{itemTitle}</div>
      <div className="summary-data">{itemAmount}</div>
    </div>
  );
};

SummaryDataItem.propTypes = {
  itemAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SummaryDataItem;
